import { t } from "i18next";
import CommonProjectInvoiceDetails from "modules/billing/components/CommonProjectInvoiceDetails";
import { useCallback, useState } from "react";

import Button from "~/components/buttons/Button";
import SidebarBusyOverlay from "~/components/Sidebar/components/SidebarBusyOverlay";
import SidebarErrorOverlay from "~/components/Sidebar/components/SidebarErrorOverlay";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";
import SidebarHeaderHeadline from "~/components/Sidebar/components/SidebarHeaderHeadline";
import { revertDraftInvoiceStatusToPending } from "~/modules/billing/api/draftInvoice/draftInvoiceApiDispatchers.ts";
import type { UnprocessedInvoicesIndexTableData } from "~/modules/billing/components/unprocessedInvoicesTableTypes.ts";
import type { User, UserWithConfidentialInformation } from "~/modules/user/api/user/userTypes.ts";

type Props = {
	allUsersData: User[] | UserWithConfidentialInformation[];
	onCancel: () => void;
	onSuccess: () => void;
	pendingInvoiceData: UnprocessedInvoicesIndexTableData;
};

const RevertDraftProjectInvoiceStatusForm = ({ allUsersData, onCancel, onSuccess, pendingInvoiceData }: Props) => {
	const [isBusy, setIsBusy] = useState<boolean>(false);
	const [serverErrorMessage, setServerErrorMessage] = useState<string>("");
	const onSubmit = useCallback(async () => {
		try {
			setIsBusy(true);
			await revertDraftInvoiceStatusToPending(pendingInvoiceData.id);
			onSuccess();
		} catch (error) {
			console.log(error);
			setServerErrorMessage(t("form:unexpectedError"));
			setIsBusy(false);
		}
	}, [onSuccess, pendingInvoiceData.id]);

	return <>
		<SidebarHeader>
			<SidebarHeaderHeadline>Rechnungsstatus zurücksetzen</SidebarHeaderHeadline>

		</SidebarHeader>
		<div className="grow overflow-auto px-7 py-2">
			{isBusy && <SidebarBusyOverlay />}
			{serverErrorMessage &&
				<SidebarErrorOverlay title="Statusupdate fehlgeschlagen">{serverErrorMessage}</SidebarErrorOverlay>}
			<CommonProjectInvoiceDetails allUsersData={allUsersData}
										 invoiceData={pendingInvoiceData}
										 staffingsClosingStatuses={pendingInvoiceData.staffingsClosingStatuses}>
			</CommonProjectInvoiceDetails>
		</div>
		<SidebarFooter>
			<Button theme="danger"
					onClick={onSubmit}
			>
				Status in &quot;Offen&quot; ändern
			</Button>
			<Button theme="none"
					onClick={onCancel}>
				Abbrechen
			</Button>
		</SidebarFooter>
	</>;
};

export default RevertDraftProjectInvoiceStatusForm;